<div appDropdown role="navigation" tabindex="0">
  <button class="toggle-dropdown" aria-label="menuEscondido">
    <svg
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.495117" y="16" width="23.9169" height="4" fill="white" />
      <rect x="0.495117" y="8" width="23.9169" height="4" fill="white" />
      <rect x="0.495117" width="23.9169" height="4" fill="white" />
    </svg>
  </button>
  <div class="dropdown bg-color-white" id="dropdown">
    <ul class="nav">
      <li class="navigation-group">
        <ul>
          <li class="navigation-link">
            <a routerLink="apresentacao" class="link">Apresentação</a>
          </li>
          <li class="navigation-link">
            <a routerLink="legislacao" class="link">Legislação</a>
          </li>
          <li class="navigation-link">
            <a routerLink="/lista-de-termos" class="link">Lista de termos</a>
          </li>
          <li class="navigation-link">
            <a routerLink="/faq" class="link">Perguntas frequentes</a>
          </li>
          <li class="navigation-link">
            <a routerLink="expediente" class="link">Expediente</a>
          </li>
          <p class="navigation-title text-uppercase">Encontre um Curso</p>
          <li class="navigation-link">
            <a routerLink="/cursos" class="link">Todos os cursos</a>
          </li>
          <li class="navigation-link">
            <a [routerLink]="['/']" fragment="eixo-tecnologico" class="link"
              >Cursos por eixo tecnológico</a
            >
          </li>

          <!-- li class="navigation-link">
            <a routerLink="/cursos/mudaram-nome" class="link">Cursos que mudaram de nome</a>
          </li -->

          <li class="navigation-link">
            <a
              routerLink="/cursos/mudaram-nome-tabela-convergencia"
              [queryParams]="{ filtro: 'mudaramnome' }"
              class="link"
              >Tabela de Convergência
            </a>
          </li>

          <!-- li class="navigation-link">
            <a routerLink="/cursos/nao-autorizados" class="link"
              >Cursos excluídos ou não incluídos</a
            >
          </li -->

          <li class="navigation-link">
            <a routerLink="/cursos/tabela-submissao" class="link"
              >Tabela de Submissão
            </a>
          </li>

          <li class="navigation-link">
            <a routerLink="/cursos/experimentais" class="link"
              >Cursos em oferta experimental</a
            >
          </li>
          <p class="navigation-title text-uppercase">Downloads</p>
          <li class="navigation-link">
            <a
              target="_blank"
              rel="noopener"
              href="/cnct-api/catalogopdf"
              class="link"
              >Catálogo em PDF</a
            >
          </li>
          <li class="navigation-link">
            <a
              target="_blank"
              rel="noopener"
              (click)="downloadCsvCatalogoCnct()"
              class="link"
              >Catálogo em CSV</a
            >
          </li>
          <li class="navigation-link">
            <a
              target="_blank"
              rel="noopener"
              href="/cnct-api/relatorio-dados-atualizadospdf"
              class="link"
              >Registro de Alterações no Portal</a
            >
          </li>
          <li class="navigation-link">
            <a routerLink="todas-edicoes" class="link">Todas as Edições</a>
          </li>
          <p class="navigation-title text-uppercase">
            Ajude a melhorar o Catálogo
          </p>
          <li class="navigation-link">
            <a routerLink="/envie-sugestao" class="link"
              >Envie sua sugestão de melhoria</a
            >
          </li>
        </ul>
      </li>
      <li class="navigation-group">
        <ul>
          <p class="navigation-title text-uppercase">
            <a
              href="https://www.gov.br/mec/pt-br/canais_atendimento"
              class="link"
              target="_blank"
              rel="noopener"
              >Canais de Comunicação</a
            >
          </p>
          <li class="navigation-link">
            <a
              href="https://www.gov.br/mec/pt-br/canais_atendimento/fale-conosco"
              class="link"
              target="_blank"
              rel="noopener"
              >Fale conosco</a
            >
          </li>
          <li>
            <p class="navigation-title text-uppercase icones">Redes Sociais</p>
            <app-social-networks></app-social-networks>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</div>
